import { Box, type BoxProps, CircularProgress, useTheme } from "@mui/material";
import { FoodsLoadingIndicator } from "src/components/EntityForm/FoodsFields";
import type { ComponentAppearance } from "src/components/appearance";

interface LoadingProps extends BoxProps {
    size?: number;
    appearance?: ComponentAppearance;
}

export function Loading({ size, appearance = "legacy", ...boxProps }: LoadingProps) {
    const theme = useTheme();
    const isProductUxV2 = appearance === "product-v2";
    const label = typeof boxProps["aria-label"] === "string" ? boxProps["aria-label"] : "Loading";

    return (
        <Box
            sx={{
                marginLeft: "auto",
                marginRight: "auto",
                width: "fit-content",
                marginTop: "5%",
                marginBottom: "5%",
            }}
            {...boxProps}
        >
            {isProductUxV2 ?
                <FoodsLoadingIndicator label={label} size={size ?? theme.spacing(5)} />
            :   <CircularProgress aria-label={label} size={size} />}
        </Box>
    );
}
